import React, { useEffect, useState } from "react";
import "./image-slider.scss";
import { MdOutlineArrowLeft, MdOutlineArrowRight } from "react-icons/md";

const SliderData = [
  {
    id: 0,
    image:
      "https://images.unsplash.com/photo-1546768292-fb12f6c92568?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80",
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1475189778702-5ec9941484ae?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1351&q=80",
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1503177119275-0aa32b3a9368?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80",
  },
];

const ImageSlider = () => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const length = SliderData.length;

  const prevSlide = () =>
    setCurrentSlide(currentSlide === 0 ? length - 1 : currentSlide - 1);

  const nextSlide = () =>
    setCurrentSlide(currentSlide === length - 1 ? 0 : currentSlide + 1);

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(timer);
  });

  if (!Array.isArray(SliderData) || SliderData.length <= 0) {
    return null;
  }

  return (
    <div className="image-slider-content">
      <MdOutlineArrowLeft
        className="image-slider-content-arrow image-slider-content-arrow_left"
        onClick={prevSlide}
      />
      <MdOutlineArrowRight
        className="image-slider-content-arrow image-slider-content-arrow_right"
        onClick={nextSlide}
      />
      {SliderData.map((slide, index) => (
        <div
          key={slide.id}
          className={
            index === currentSlide
              ? "image-slider-content-slide-active"
              : "image-slider-content-slide"
          }
        >
          {index === currentSlide && (
            <img
              src={slide.image}
              alt="image"
              className="image-slider-content-image"
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ImageSlider;
